/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_TypeInputs */

const en_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const fr_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const it_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ru_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const es_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const zh_cn2_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const ja_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const hi_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const pt_pt2_manual_qc_export_type = /** @type {(inputs: Manual_Qc_Export_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Manual_Qc_Export_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_type = /** @type {((inputs?: Manual_Qc_Export_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_type(inputs)
	if (locale === "de") return de_manual_qc_export_type(inputs)
	if (locale === "it") return it_manual_qc_export_type(inputs)
	if (locale === "ru") return ru_manual_qc_export_type(inputs)
	if (locale === "es") return es_manual_qc_export_type(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_type(inputs)
	if (locale === "ja") return ja_manual_qc_export_type(inputs)
	if (locale === "hi") return hi_manual_qc_export_type(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_type(inputs)
	return en_manual_qc_export_type(inputs)
});